import React from 'react'
import { Geolocation } from './styles'
import { Message } from '../type'

interface Props {
  type: 'sent' | 'received'
  message: Message
}

const GeolocationMessage: React.FC<Props> = ({ message }) => (
  <Geolocation
    src={`https://maps.google.com/maps?q=${message.geolocation?.latitude},${message.geolocation?.longitude}&z=15&output=embed`}
    width="250"
    height="200"
    frameBorder="0"
    style={{
      border: 0,
    }}
  ></Geolocation>
)

export default GeolocationMessage
